/**
 * WordPress dependencies
 */
import { store, getContext,getElement } from '@wordpress/interactivity';

const { state } = store( 'clientar-blocks', {
	state: {},
	actions: {},
	callbacks: {},
} );
